import React from 'react';
import { string, func, bool } from 'prop-types';

import { CommentInfoWrap } from './styles';
import { ReactQuillWrapped } from '../../components/react-quill';


export const CommentInfo = (props) => {
  const {
    text,
    theme,
    readOnly,
    onTextChange,
  } = props;

  return (
    <CommentInfoWrap id="commentInfo">
      <ReactQuillWrapped
        value={text}
        theme={theme}
        readOnly={readOnly}
        bounds="#commentInfo"
        onChange={onTextChange}
        withPaddings={!readOnly}
        scrollingContainer="#commentInfo"
        height={readOnly ? 'auto' : '400px'}
      />
    </CommentInfoWrap>
  );
};

CommentInfo.propTypes = {
  readOnly: bool,
  onTextChange: func,
  text: string.isRequired,
  theme: string.isRequired,
};

CommentInfo.defaultProps = {
  readOnly: false,
  onTextChange: null,
};



// WEBPACK FOOTER //
// ./src/modals/comments-modal/comment-info.js